import React from 'react'
import { Container, Paper, Typography, Button, Stack } from '@mui/material'

const REASON_TEXT = {
  expired:   'Diese Einladung ist abgelaufen. Bitte wenden Sie sich an Ihren Administrator, um eine neue Einladung zu erhalten.',
  accepted:  'Diese Einladung wurde bereits angenommen. Sie können sich direkt anmelden.',
  not_found: 'Diese Einladung ist ungültig oder existiert nicht.',
}

export default function InvitationInvalid({ reason = 'not_found' }) {
  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Paper sx={{ p: 4 }}>
        <Stack spacing={2}>
          <Typography variant="h5">Einladung ungültig</Typography>
          <Typography variant="body2" color="text.secondary">
            {REASON_TEXT[reason] || REASON_TEXT.not_found}
          </Typography>
          <Button href="/login" variant="contained" data-testid="go-to-login">
            Zur Anmeldung
          </Button>
        </Stack>
      </Paper>
    </Container>
  )
}
